module.exports = __webpack_public_path__ + "img/brde-award.1b25e425.png";